import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.xray.label_review');
import { ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Service } from "src/libs/portal/season/service";
import {
    XRAY_OPERATING_POSE_CONNECTIONS,
    XRAY_OPERATING_POSE_STYLE,
} from "src/libs/portal/season/xray-pose-skeleton";

const STATUS_OPTIONS = ['AUTO_ACCEPTED', 'HUMAN_CORRECTED', 'HUMAN_RELABELED', 'EXCLUDED'];
const GROUP_OPTIONS = ['NORMAL', 'CORRECTION', 'HARD_CASE', 'EXCLUDED'];
const VISIBILITY_OPTIONS = ['visible', 'occluded', 'not_labeled'];
const PRIORITY_IDS = new Set([0, 11, 12, 13, 14, 15, 16, 23, 24]);
const BUCKY_CORNERS = ['top_left', 'top_right', 'bottom_right', 'bottom_left'];
const KO_NAMES = [
    '머리 중심(코)', '왼쪽 눈 안쪽', '왼쪽 눈', '왼쪽 눈 바깥', '오른쪽 눈 안쪽', '오른쪽 눈', '오른쪽 눈 바깥',
    '왼쪽 귀', '오른쪽 귀', '입 왼쪽', '입 오른쪽', '왼쪽 어깨', '오른쪽 어깨', '왼쪽 팔꿈치',
    '오른쪽 팔꿈치', '왼쪽 손목', '오른쪽 손목', '왼쪽 새끼손가락', '오른쪽 새끼손가락',
    '왼쪽 검지', '오른쪽 검지', '왼쪽 엄지', '오른쪽 엄지', '왼쪽 골반', '오른쪽 골반',
    '왼쪽 무릎', '오른쪽 무릎', '왼쪽 발목', '오른쪽 발목', '왼쪽 발뒤꿈치',
    '오른쪽 발뒤꿈치', '왼쪽 발끝', '오른쪽 발끝'
];

@Component({ standalone: false,
    selector: 'wiz-page-xray-label_review',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.xray.label_review/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.label-review-shell.detector-focused {
  min-height: 100vh;
  background: radial-gradient(circle at 55% 35%, rgba(14, 165, 233, 0.07), transparent 32rem), #f8fafc;
  color: #0f172a;
}

.detector-focused .review-header {
  position: sticky;
  top: 0;
  z-index: 60;
  border-color: #e2e8f0;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(12px);
}

.detector-focused .review-header > div {
  max-width: none;
  padding: 0.55rem 0.75rem;
}

.detector-focused .review-header h1,
.detector-focused .review-header button {
  color: #0f172a;
}

.detector-focused .review-header p {
  color: #64748b;
}

.detector-focused .review-header button {
  border-color: #cbd5e1;
  background: #ffffff;
}

.detector-focused .review-main {
  max-width: none;
  padding: 0.5rem;
}

.detector-focused .review-workflow {
  display: none;
}

.detector-focused .review-summary {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
}

.detector-focused .review-summary > div {
  padding: 0.75rem !important;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05);
}

.detector-focused .review-workspace {
  display: grid;
  grid-template-columns: minmax(220px, 17vw) minmax(480px, 1fr) minmax(300px, 22vw);
  align-items: start;
  gap: 0.5rem;
  min-height: calc(100vh - 10.5rem);
}

.detector-focused .review-queue,
.detector-focused .review-stage,
.detector-focused .review-inspector {
  min-width: 0;
  max-height: calc(100vh - 10.5rem);
}

.detector-focused .review-queue,
.detector-focused .review-stage,
.detector-focused .review-inspector > section {
  border-color: #dbe4ee !important;
  background: #ffffff !important;
  color: #0f172a;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.08);
}

.detector-focused .review-queue {
  position: sticky;
  top: 9.5rem;
  contain: layout paint;
}

.detector-focused .review-queue > div:first-child {
  border-color: #e2e8f0;
  background: #ffffff;
}

.detector-focused .review-queue select,
.detector-focused .review-inspector select,
.detector-focused .review-inspector textarea {
  border-color: #cbd5e1 !important;
  background: #ffffff !important;
  color: #0f172a !important;
}

.detector-focused .review-queue-list {
  max-height: calc(100vh - 16rem);
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}

.detector-focused .review-queue-item {
  content-visibility: auto;
  contain-intrinsic-size: 78px;
  border-color: #e2e8f0 !important;
  background: #ffffff;
  color: #334155;
}

.detector-focused .review-queue-item:hover {
  background: #f8fafc;
}

.detector-focused .review-queue-item.bg-sky-50 {
  box-shadow: inset 3px 0 #0284c7;
  background: #e0f2fe !important;
}

.detector-focused .review-queue-item .text-slate-500 {
  color: #64748b !important;
}

.detector-focused .review-stage {
  contain: layout paint;
  border-color: #dbe4ee !important;
  background: #ffffff !important;
  padding: 0.65rem;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}

.detector-focused .review-media-viewport {
  max-height: calc(100vh - 22rem) !important;
  background: #f1f5f9;
  overscroll-behavior: contain;
}

.detector-focused .review-media-viewport img,
.detector-focused .review-media-viewport video {
  /* The viewport owns the visible-height limit. The media itself must be
     free to grow uniformly when Bucky-fit zoom is selected. */
  max-height: calc(100vh - 22rem);
  height: auto;
  object-fit: contain;
  background: #f1f5f9 !important;
}

.detector-focused .review-stage > div:first-child {
  color: #0f172a !important;
}

.detector-focused .review-stage > div:first-child .text-slate-400 {
  color: #64748b !important;
}

.detector-focused .review-stage > div:first-child .text-fuchsia-200 {
  color: #a21caf !important;
}

.detector-focused .review-stage > div:first-child .text-amber-300 {
  color: #b45309 !important;
}

.detector-focused [data-testid=image-zoom-toolbar] {
  background: #f1f5f9 !important;
  color: #334155 !important;
}

.detector-focused [data-testid=image-zoom-toolbar] button {
  border-color: #94a3b8 !important;
  color: #334155 !important;
}

.detector-focused [data-testid=bucky-video-temporal-review] {
  border-color: #6ee7b7 !important;
  background: #ecfdf5 !important;
  color: #065f46 !important;
}

.detector-focused .review-inspector {
  position: sticky;
  top: 9.5rem;
  overflow-y: auto;
  padding-right: 0.2rem;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  contain: layout paint;
}

.detector-focused .review-inspector > section {
  padding: 0.8rem !important;
}

/* Detector mode uses the compact controls below the shared editor. */
.detector-focused .detector-only-inspector > section:first-of-type,
.detector-focused .detector-only-inspector > [data-testid=hard-negative-review-action] {
  display: none;
}

.detector-focused .review-inspector .text-slate-500,
.detector-focused .review-inspector .text-slate-600,
.detector-focused .review-inspector .text-slate-700 {
  color: #475569 !important;
}

.detector-focused .review-inspector .text-amber-700,
.detector-focused .review-inspector .text-amber-800,
.detector-focused .review-inspector .text-amber-900 {
  color: #92400e !important;
}

.detector-focused .review-inspector .text-cyan-700,
.detector-focused .review-inspector .text-cyan-800,
.detector-focused .review-inspector .text-sky-700 {
  color: #0e7490 !important;
}

.detector-focused .review-inspector [data-testid=bucky-edge-checklist] {
  border-color: #a5f3fc !important;
  background: #ecfeff !important;
  color: #334155 !important;
}

.detector-focused .review-inspector [data-testid=hard-negative-review-action] {
  border-color: #fde68a !important;
  background: #fffbeb !important;
}

.detector-focused .review-inspector button:not([disabled]) {
  transition: border-color 120ms ease, background-color 120ms ease, transform 120ms ease;
}

.detector-focused .review-inspector button:not([disabled]):active {
  transform: translateY(1px);
}

@media (max-width: 1180px) {
  .detector-focused .review-workspace {
    grid-template-columns: 220px minmax(440px, 1fr);
  }
  .detector-focused .review-inspector {
    position: static;
    grid-column: 1/-1;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    max-height: none;
    overflow: visible;
  }
}
@media (max-width: 820px) {
  .detector-focused .review-workspace {
    display: block;
  }
  .detector-focused .review-queue,
  .detector-focused .review-stage,
  .detector-focused .review-inspector {
    position: static;
    max-height: none;
    margin-bottom: 0.5rem;
  }
  .detector-focused .review-queue-list {
    max-height: 18rem;
  }
  .detector-focused .review-inspector {
    display: block;
  }
  .detector-focused .review-inspector > section + section {
    margin-top: 0.5rem;
  }
}`],
})
export class PageXrayLabel_reviewComponent implements OnInit, OnDestroy {
    public readonly operatingPoseStyle = XRAY_OPERATING_POSE_STYLE;
    public summary: any = {};
    public items: any[] = [];
    public current: any = null;
    public draft: any = null;
    public currentIndex = 0;
    public loading = false;
    public saving = false;
    public notice = '';
    public errorMessage = '';
    public statusFilter = 'UNREVIEWED';
    public groupFilter = '';
    public mediaFilter: 'image' | 'video' = 'image';
    public mediaSelectionExplicit = false;
    public equipmentBatchOnly = false;
    public publicEquipmentOnly = false;
    public detectorOnlyMode = false;
    public detectorReauditMode = false;
    public selectedPointId = 11;
    public showAllPoints = false;
    public developerMode = false;
    public showPersonBbox = false;
    public showModelPrediction = true;
    public gtCaptureMode = false;
    public gtCaptureIndex = 0;
    public imageMetrics: any = { naturalWidth: 0, naturalHeight: 0, displayWidth: 0, displayHeight: 0, scaleX: 0, scaleY: 0 };
    public baseImageDisplay: any = { width: 0, height: 0 };
    public zoomScale = 1;
    public zoomMode: 'full' | 'manual' | 'upper' | 'bucky' = 'full';
    public equipmentChecklist: any = {
        outerEdges: false,
        occludedEdges: false,
        personIndependent: false,
    };
    public equipmentChecklistDetailsOpen = false;
    public roundtripCheck: any = null;
    public videoPreparing = false;
    public videoLoadError = false;
    public videoPlaying = false;
    public videoAtReviewFrame = true;
    public videoEditingCurrentFrame = false;
    public videoFramePreparing = false;
    public videoRelinking = false;
    public videoCurrentTime = 0;
    public videoObjectUrl = '';
    public liveDetectorPolygon: any = null;
    public liveDetectorRawPolygon: any = null;
    public liveInferenceBusy = false;
    public liveInferenceCount = 0;
    public liveDetectionCount = 0;
    public liveMovementEvents = 0;
    public liveMaxCenterShift = 0;
    public liveStartSeconds = 0;
    public liveEndSeconds = 0;
    public liveInferenceError = '';
    public liveInferenceSourceTime = -1;
    public liveAppliedBoxSource = 'AI_PREDICTION';
    public liveAnchorDriftScore = 0;
    public liveMissStreak = 0;
    private pendingVideoFrame: any = null;
    private requestedReviewItemId = '';
    private dragMode: 'bbox-move' | 'bbox-resize' | 'bucky-corner' | 'bucky-move' | 'pose' | '' = '';
    private dragHandle = '';
    private dragPointId = -1;
    private dragStart: any = null;
    private moveHandler = (event: PointerEvent) => this.onPointerMove(event);
    private upHandler = () => this.endDrag();
    private resizeHandler = () => this.updateImageMetrics();
    private videoLoadVersion = 0;
    private loadGeneration = 0;
    private liveInferenceGeneration = 0;
    private liveInferenceTimer: any = null;
    private livePreviousCenter: any = null;
    private liveFirstCenter: any = null;
    private readonly liveInferenceDelayMs = 140;
    private readonly liveCaptureMaxWidth = 640;
    private readonly liveManualReviewThreshold = 0.06;
    private readonly livePredictionHoldFrames = 3;
    private readonly labelReviewRuntimeApi = '/wiz/api/page.xray.label_review_runtime_v7/';
    private readonly liveTrackingId = 'bucky-reaudit-' + Math.random().toString(36).slice(2, 12);

    constructor(@Inject( Service)         public service: Service,@Inject( ChangeDetectorRef)         public ref: ChangeDetectorRef,@Inject( Router)         public router: Router,@Inject( TranslateService    )         public translate: TranslateService    ) {}

    public async ngOnInit() {
        await this.service.init(this);
        this.developerMode = new URLSearchParams(window.location.search).get('developer') === '1';
        const query = new URLSearchParams(window.location.search);
        const reviewMode = query.get('mode');
        const requestedMedia = query.get('media');
        this.mediaSelectionExplicit = requestedMedia === 'image' || requestedMedia === 'video';
        this.mediaFilter = requestedMedia === 'video' ? 'video' : 'image';
        this.requestedReviewItemId = query.get('review_item') || '';
        if (reviewMode === 'bucky-public') {
            this.publicEquipmentOnly = true;
            this.detectorOnlyMode = true;
            this.statusFilter = '';
        } else if (reviewMode === 'bucky-reaudit') {
            this.detectorReauditMode = true;
            this.detectorOnlyMode = true;
            this.publicEquipmentOnly = true;
            this.statusFilter = '';
        }
        document.addEventListener('pointermove', this.moveHandler);
        document.addEventListener('pointerup', this.upHandler);
        window.addEventListener('resize', this.resizeHandler);
        await this.load();
    }

    public ngOnDestroy() {
        document.removeEventListener('pointermove', this.moveHandler);
        document.removeEventListener('pointerup', this.upHandler);
        window.removeEventListener('resize', this.resizeHandler);
        this.stopLiveInference(true);
        this.releaseVideoObjectUrl();
    }

    public go(path: string) { this.service.href(path); }
    public statusOptions() { return STATUS_OPTIONS; }
    public groupOptions() { return GROUP_OPTIONS; }
    public visibilityOptions() { return VISIBILITY_OPTIONS; }
    public statusLabel(value: string) {
        return ({AUTO_ACCEPTED: '자동 예측 확인', HUMAN_CORRECTED: '일부 수정', HUMAN_RELABELED: '전체 재라벨', EXCLUDED: '학습 제외', UNREVIEWED: '미검수'} as any)[value] || value;
    }
    public groupLabel(value: string) {
        return ({NORMAL: 'A · 정상 검출', CORRECTION: 'B · 교정', HARD_CASE: 'C · 실패/Hard case', EXCLUDED: '학습 제외'} as any)[value] || value;
    }
    public visibilityLabel(value: string) {
        return ({visible: '보임', occluded: '가림', not_labeled: '미라벨'} as any)[value] || value;
    }
    public mediaTypeLabel(value: string) { return value === 'video' ? '동영상' : '사진'; }
    public trackByImageId(_index: number, item: any) { return item?.image_id || _index; }
    public trackByCornerName(_index: number, point: any) { return point?.name || _index; }
    public mediaSourceLabel(item: any) {
        if (item?.media_type !== 'video') return '원본 사진';
        const seconds = Number(item?.video_time_seconds);
        const time = Number.isFinite(seconds) ? ` · ${seconds.toFixed(1)}초` : '';
        return `${item?.source_filename || '원본 동영상'}${time}`;
    }

    public async load() {
        const loadGeneration = ++this.loadGeneration;
        const requestedMedia = this.mediaFilter;
        this.loading = true; this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('load', {
                status: this.statusFilter,
                group: this.groupFilter,
                queue: 'pilot60-v1',
                equipment_batch: this.equipmentBatchOnly ? 'true' : 'false',
                public_equipment: this.publicEquipmentOnly ? 'true' : 'false',
                detector_reaudit: this.detectorReauditMode ? 'true' : 'false',
                media_type: requestedMedia,
            });
            if (loadGeneration !== this.loadGeneration) return;
            if (code !== 200) throw new Error(data?.message || '목록을 불러오지 못했습니다.');
            let nextSummary = data?.summary || {};
            const responseItems = data?.items || [];
            let nextItems = responseItems.filter(
                (item: any) => item?.media_type === requestedMedia
            );
            let autoSwitchNotice = '';
            const remainingReaudit = Number(
                nextSummary?.detector_reaudit_review?.remaining_count || 0
            );
            if (this.detectorReauditMode && !this.mediaSelectionExplicit && remainingReaudit > 0 && !nextItems.length) {
                const alternateMedia: 'image' | 'video' = requestedMedia === 'image' ? 'video' : 'image';
                let alternateItems = responseItems.filter(
                    (item: any) => item?.media_type === alternateMedia
                );
                if (!alternateItems.length) {
                    const alternate = await wiz.call('load', {
                        status: this.statusFilter,
                        group: this.groupFilter,
                        queue: 'pilot60-v1',
                        equipment_batch: this.equipmentBatchOnly ? 'true' : 'false',
                        public_equipment: this.publicEquipmentOnly ? 'true' : 'false',
                        detector_reaudit: 'true',
                        media_type: alternateMedia,
                    });
                    if (loadGeneration !== this.loadGeneration) return;
                    if (alternate?.code === 200) {
                        nextSummary = alternate?.data?.summary || nextSummary;
                        alternateItems = (alternate?.data?.items || []).filter(
                            (item: any) => item?.media_type === alternateMedia
                        );
                    }
                }
                if (alternateItems.length) {
                    this.mediaFilter = alternateMedia;
                    nextItems = alternateItems;
                    autoSwitchNotice = requestedMedia === 'image'
                        ? '사진 라벨링이 완료되어 남은 동영상 라벨링으로 자동 전환했습니다.'
                        : '동영상 라벨링이 완료되어 남은 사진 라벨링으로 자동 전환했습니다.';
                }
            }
            this.summary = nextSummary;
            this.items = nextItems;
            const requestedIndex = this.requestedReviewItemId
                ? this.items.findIndex(
                    (item: any) => item?.image_id === this.requestedReviewItemId
                )
                : -1;
            this.currentIndex = requestedIndex >= 0
                ? requestedIndex
                : Math.min(
                    this.currentIndex,
                    Math.max(0, this.items.length - 1)
                );
            await this.openCurrent(false, loadGeneration);
            if (autoSwitchNotice) this.notice = autoSwitchNotice;
        } catch (error: any) {
            if (loadGeneration !== this.loadGeneration) return;
            this.errorMessage = error?.message || '목록을 불러오지 못했습니다.';
        }
        if (loadGeneration !== this.loadGeneration) return;
        this.loading = false; await this.service.render();
    }

    public async applyFilters() { this.currentIndex = 0; await this.load(); }

    public async setMediaFilter(value: string) {
        const nextMedia: 'image' | 'video' = value === 'video' ? 'video' : 'image';
        this.mediaSelectionExplicit = true;
        if (this.mediaFilter === nextMedia && !this.loading) return;
        this.mediaFilter = nextMedia;
        this.currentIndex = 0;
        await this.load();
    }

    public detectorReviewHasPending() {
        return this.detectorReauditMode
            && Number(this.summary?.detector_reaudit_review?.remaining_count || 0) > 0;
    }

    public async toggleEquipmentBatch() {
        this.equipmentBatchOnly = !this.equipmentBatchOnly;
        this.publicEquipmentOnly = false;
        this.detectorOnlyMode = this.equipmentBatchOnly;
        this.statusFilter = 'UNREVIEWED';
        this.groupFilter = '';
        await this.applyFilters();
    }

    public async togglePublicEquipmentReview() {
        if (this.detectorOnlyMode && this.publicEquipmentOnly) return;
        this.publicEquipmentOnly = !this.publicEquipmentOnly;
        this.equipmentBatchOnly = false;
        this.detectorOnlyMode = this.publicEquipmentOnly;
        this.statusFilter = this.publicEquipmentOnly ? '' : 'UNREVIEWED';
        this.groupFilter = '';
        await this.applyFilters();
    }

    public async showAllReviews() {
        this.statusFilter = '';
        await this.applyFilters();
    }
    public togglePersonBbox() {
        this.showPersonBbox = !this.showPersonBbox;
        this.service.render();
    }
    public toggleModelPrediction() {
        this.showModelPrediction = !this.showModelPrediction;
        this.service.render();
    }

    public async open(index: number) {
        this.currentIndex = Math.max(0, Math.min(this.items.length - 1, index));
        await this.openCurrent();
    }

    public async move(delta: number) { await this.open(this.currentIndex + delta); }

    private async loadReviewDetail(imageId: string, validationOnly = false) {
        const query = new URLSearchParams({
            image_id: String(imageId || ''),
            validation_only: validationOnly ? 'true' : 'false',
        });
        const response = await fetch(this.labelReviewRuntimeApi + 'detail?' + query.toString(), {
            credentials: 'same-origin',
        });
        return await response.json();
    }

    private async openCurrent(render = true, expectedLoadGeneration?: number) {
        if (
            expectedLoadGeneration !== undefined
            && expectedLoadGeneration !== this.loadGeneration
        ) return;
        this.stopLiveInference(true);
        this.releaseVideoObjectUrl();
        this.videoLoadVersion += 1;
        const row = this.items[this.currentIndex];
        if (!row) { this.current = null; this.draft = null; if (render) await this.service.render(); return; }
        this.notice = ''; this.errorMessage = '';
        this.roundtripCheck = null;
        try {
            const { code, data } = await this.loadReviewDetail(row.image_id);
            if (
                expectedLoadGeneration !== undefined
                && expectedLoadGeneration !== this.loadGeneration
            ) return;
            if (code !== 200) throw new Error(data?.message || '라벨을 불러오지 못했습니다.');
            this.current = data?.item;
            this.draft = JSON.parse(JSON.stringify(this.current?.draft || {}));
            this.equipmentChecklist = {
                outerEdges: Boolean(this.draft?.equipment_gt_checklist?.outer_edges),
                occludedEdges: Boolean(this.draft?.equipment_gt_checklist?.occluded_edges),
                personIndependent: Boolean(this.draft?.equipment_gt_checklist?.person_independent),
            };
            this.selectedPointId = 11;
            this.zoomScale = 1;
            this.zoomMode = 'full';
            this.baseImageDisplay = { width: 0, height: 0 };
            this.videoPreparing = this.isVideoReview() && this.videoAvailable();
            this.videoLoadError = false;
            this.videoPlaying = false;
            this.videoAtReviewFrame = true;
            this.videoEditingCurrentFrame = false;
            this.videoFramePreparing = false;
            this.pendingVideoFrame = null;
            this.videoCurrentTime = this.reviewFrameTime();
            setTimeout(() => this.updateImageMetrics(), 0);
            if (this.videoPreparing) void this.prepareVideoPlayback(this.videoLoadVersion);
        } catch (error: any) {
            this.errorMessage = error?.message || '라벨을 불러오지 못했습니다.';
        }
        if (render) await this.service.render();
    }

    public imageUrl() {
        return this.current?.image_id
            ? '/wiz/api/page.xray.label_review/image?image_id=' + encodeURIComponent(this.current.image_id)
            : '';
    }

    public isVideoReview() { return this.current?.media?.type === 'video_frame'; }
    public videoAvailable() { return this.isVideoReview() && this.current?.media?.video_available === true; }
    public reviewFrameTime() { return Number(this.current?.media?.video_time_seconds || 0); }
    public videoUrl() {
        return this.current?.image_id && this.videoAvailable()
            ? '/wiz/api/page.xray.label_review/image?image_id=' + encodeURIComponent('video:' + this.current.image_id)
            : '';
    }
    public async relinkDetectorVideoSource(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        input.value = '';
        if (!file || !this.current?.image_id || this.videoRelinking) return;
        this.videoRelinking = true;
        this.errorMessage = '';
        this.notice = '';
        await this.service.render();
        try {
            const form = new FormData();
            form.append('operation', 'relink_detector_video_source');
            form.append('image_id', String(this.current.image_id));
            form.append('file', file, file.name);
            const http = await fetch(this.labelReviewRuntimeApi + 'save', {
                method: 'POST', body: form, credentials: 'same-origin',
            });
            const response = await http.json();
            const { code, data } = response || {};
            if (code !== 200 || !data?.relinked || !data?.item) {
                throw new Error(data?.message || '원본 동영상을 다시 연결하지 못했습니다.');
            }
            this.stopLiveInference(true);
            this.releaseVideoObjectUrl();
            this.videoLoadVersion += 1;
            this.current = data.item;
            this.draft = JSON.parse(JSON.stringify(data.item.draft || {}));
            this.summary = data?.summary || this.summary;
            this.videoLoadError = false;
            this.videoAtReviewFrame = true;
            this.videoCurrentTime = this.reviewFrameTime();
            this.videoPreparing = this.videoAvailable();
            this.notice = `원본 ${file.name}을 확인해 다시 연결했습니다. 동영상 재생과 현재 프레임 수정이 가능합니다.`;
            if (this.videoPreparing) void this.prepareVideoPlayback(this.videoLoadVersion);
        } catch (error: any) {
            this.errorMessage = error?.message || '원본 동영상을 다시 연결하지 못했습니다.';
        }
        this.videoRelinking = false;
        await this.service.render();
    }
    public showReviewCoordinates() {
        return !this.videoAvailable() || this.videoLoadError
            || (!this.videoPlaying && (this.videoAtReviewFrame || this.videoEditingCurrentFrame));
    }
    public showLiveDetector() {
        return this.videoAvailable() && !this.videoLoadError
            && !this.videoEditingCurrentFrame
            && (this.videoPlaying || !this.videoAtReviewFrame)
            && this.buckyPolygonPoints(this.liveDetectorPolygon).length === 4;
    }
    public liveDetectorPolygonString() { return this.buckyPolygonString(this.liveDetectorPolygon); }
    public videoBuckyTrackingAnchors() {
        const media = this.current?.media || {};
        const candidates = Array.isArray(media.video_tracking_anchors)
            ? media.video_tracking_anchors
            : (media.video_tracking_anchor ? [media.video_tracking_anchor] : []);
        return candidates.filter((anchor: any) => (
            String(anchor?.source_video_sha256 || '') === String(media.source_video_sha256 || '')
            && this.buckyPolygonPoints(anchor?.raw_polygon).length === 4
            && this.buckyPolygonPoints(anchor?.corrected_polygon).length === 4
        ));
    }
    private videoBuckyTrackingAnchor(timeSeconds = this.videoCurrentTime) {
        const anchors = this.videoBuckyTrackingAnchors();
        if (!anchors.length) return null;
        return [...anchors].sort((first: any, second: any) => (
            Math.abs(Number(first.timestamp_seconds || 0) - timeSeconds)
            - Math.abs(Number(second.timestamp_seconds || 0) - timeSeconds)
        ))[0];
    }
    public videoBuckyAnchorActive() { return Boolean(this.videoBuckyTrackingAnchor()); }
    public videoGtFrameCount() {
        return Number(this.current?.media?.video_frame_gt_history?.length || 0);
    }
    public currentFrameGtSaved() {
        return Boolean(this.current?.saved?.gt_saved);
    }
    public currentBuckyPositionStatus() {
        if (this.videoEditingCurrentFrame) return '사용자 보정';
        if (!this.videoPlaying && this.videoAtReviewFrame && this.currentFrameGtSaved()) return '사용자 보정';
        if (this.liveAppliedBoxSource === 'USER_GT_TRACKED') return '사용자 보정';
        if (this.liveAppliedBoxSource === 'USER_GT_HOLD') return '이전 위치 유지';
        return 'AI 검출';
    }
    private applyVideoBuckyAnchor(polygon: any, timeSeconds = this.videoCurrentTime) {
        const anchor = this.videoBuckyTrackingAnchor(timeSeconds);
        if (!anchor) return JSON.parse(JSON.stringify(polygon));
        const corrected: any = {};
        for (const name of BUCKY_CORNERS) {
            const rawPoint = anchor.raw_polygon[name];
            const correctedPoint = anchor.corrected_polygon[name];
            const currentPoint = polygon[name];
            corrected[name] = {
                x: Math.max(0, Math.min(1, Number(currentPoint.x) + Number(correctedPoint.x) - Number(rawPoint.x))),
                y: Math.max(0, Math.min(1, Number(currentPoint.y) + Number(correctedPoint.y) - Number(rawPoint.y))),
            };
        }
        return corrected;
    }
    private videoAnchorShapeDrift(polygon: any, timeSeconds: number) {
        const anchor = this.videoBuckyTrackingAnchor(timeSeconds);
        if (!anchor) return 0;
        const center = (value: any) => {
            const points = this.buckyPolygonPoints(value);
            return {
                x: points.reduce((sum, point) => sum + Number(point.x), 0) / 4,
                y: points.reduce((sum, point) => sum + Number(point.y), 0) / 4,
            };
        };
        const currentCenter = center(polygon);
        const anchorCenter = center(anchor.raw_polygon);
        return Math.max(...BUCKY_CORNERS.map(name => Math.hypot(
            (Number(polygon[name].x) - currentCenter.x)
                - (Number(anchor.raw_polygon[name].x) - anchorCenter.x),
            (Number(polygon[name].y) - currentCenter.y)
                - (Number(anchor.raw_polygon[name].y) - anchorCenter.y),
        )));
    }
    public liveManualReviewRequired() {
        return this.liveAnchorDriftScore > this.liveManualReviewThreshold
            || this.liveMissStreak > this.livePredictionHoldFrames;
    }
    public temporalDetectionRate() {
        return this.liveInferenceCount ? Math.round(this.liveDetectionCount / this.liveInferenceCount * 100) : 0;
    }
    public temporalStatusLabel() {
        if (this.liveInferenceError) return this.liveInferenceError;
        if (!this.liveInferenceCount) return this.videoBuckyAnchorActive()
            ? '저장한 GT 기준이 적용되었습니다. 영상을 재생하면 보정된 Bucky 추적을 시작합니다.'
            : '영상을 재생하면 프레임별 Bucky 추적을 시작합니다.';
        return `Bucky ${this.liveDetectionCount}/${this.liveInferenceCount}프레임 (${this.temporalDetectionRate()}%) · 이동 ${this.liveMovementEvents}회 · ${this.liveEndSeconds.toFixed(1)}초${this.videoBuckyAnchorActive() ? ` · 저장 GT ${this.videoGtFrameCount()}개 기준 보정 추적` : ''}`;
    }
    public temporalValidationPayload() {
        if (!this.liveInferenceCount) return null;
        return {
            analyzed_frames: this.liveInferenceCount,
            detected_frames: this.liveDetectionCount,
            movement_events: this.liveMovementEvents,
            max_center_shift: this.liveMaxCenterShift,
            start_seconds: this.liveStartSeconds,
            end_seconds: this.liveEndSeconds,
            source_video_sha256: String(this.current?.media?.source_video_sha256 || ''),
        };
    }

    private async prepareVideoPlayback(version: number) {
        try {
            const response = await fetch(this.videoUrl(), { credentials: 'same-origin' });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const source = await response.blob();
            if (version !== this.videoLoadVersion) return;
            this.videoObjectUrl = URL.createObjectURL(
                source.type === 'video/mp4' ? source : new Blob([source], { type: 'video/mp4' })
            );
            this.videoPreparing = false;
            await this.service.render();
        } catch (_) {
            if (version !== this.videoLoadVersion) return;
            this.videoPreparing = false;
            this.videoLoadError = true;
            this.errorMessage = '원본 동영상을 재생하지 못했습니다. 대표 실패 프레임의 모서리 검수는 계속할 수 있습니다.';
            await this.service.render();
        }
    }
    private releaseVideoObjectUrl() {
        if (this.videoObjectUrl) URL.revokeObjectURL(this.videoObjectUrl);
        this.videoObjectUrl = '';
    }
    public onVideoLoadedMetadata(event: Event) {
        const video = event.target as HTMLVideoElement;
        const upper = Number.isFinite(video.duration) ? Math.max(0, video.duration - .001) : this.reviewFrameTime();
        video.currentTime = Math.max(0, Math.min(this.reviewFrameTime(), upper));
        video.pause();
        this.syncVideoPosition(video);
        setTimeout(() => this.onImageLoad(), 0);
    }
    public onVideoSeeked(event: Event) {
        const video = event.target as HTMLVideoElement;
        if (
            this.videoEditingCurrentFrame
            && Math.abs(Number(video.currentTime || 0) - Number(this.pendingVideoFrame?.timeSeconds || 0)) > .05
        ) this.cancelCurrentDetectorFrameEdit(false);
        this.syncVideoPosition(video);
        this.onImageLoad();
        if (!this.videoAtReviewFrame) void this.inferLiveVideoFrame(video, this.liveInferenceGeneration);
    }
    public onVideoPlay(event: Event) {
        const video = event.target as HTMLVideoElement;
        if (this.videoEditingCurrentFrame) {
            video.pause();
            this.notice = '현재 프레임 Bucky 수정 내용을 저장하거나 취소한 뒤 재생해 주세요.';
            this.service.render();
            return;
        }
        this.videoPlaying = true;
        this.videoAtReviewFrame = false;
        this.gtCaptureMode = false;
        this.endDrag();
        this.startLiveInference(video);
        this.service.render();
    }
    public onVideoPause(event: Event) {
        const video = event.target as HTMLVideoElement;
        this.videoPlaying = false;
        this.stopLiveInference(false);
        this.syncVideoPosition(video);
        if (!this.videoAtReviewFrame) void this.inferLiveVideoFrame(video, this.liveInferenceGeneration);
    }
    public onVideoTimeUpdate(event: Event) {
        this.videoCurrentTime = Number((event.target as HTMLVideoElement).currentTime || 0);
    }
    public onVideoPlaybackError() {
        this.stopLiveInference(false);
        this.videoLoadError = true;
        this.videoPreparing = false;
        this.videoPlaying = false;
        this.errorMessage = '원본 동영상을 재생하지 못했습니다. 대표 실패 프레임 검수로 전환했습니다.';
        this.service.render();
    }
    public returnToReviewFrame() {
        const video = document.getElementById('human-label-image') as HTMLVideoElement;
        if (!video || video.tagName !== 'VIDEO') return;
        this.cancelCurrentDetectorFrameEdit(false);
        this.stopLiveInference(false);
        video.pause();
        video.currentTime = this.reviewFrameTime();
        this.videoPlaying = false;
        this.syncVideoPosition(video);
    }
    public currentDetectorFrameEditReady() {
        return this.videoAvailable()
            && !this.videoPreparing
            && !this.videoLoadError
            && !this.videoPlaying
            && !this.videoEditingCurrentFrame
            && !this.videoFramePreparing;
    }
    public currentDetectorFrameEditLabel() {
        if (this.videoPreparing || this.videoFramePreparing) return '현재 프레임 준비 중…';
        if (this.videoPlaying) return '영상을 멈추면 Bucky 수정 가능';
        return `현재 ${this.videoCurrentTime.toFixed(1)}초 Bucky 수정`;
    }
    public currentDetectorFrameSaveReady() {
        return this.videoEditingCurrentFrame
            && Boolean(this.pendingVideoFrame?.blob)
            && this.canConfirmEquipmentGt();
    }
    private capturePausedVideoFrame(video: HTMLVideoElement) {
        return new Promise<Blob | null>(resolve => {
            if (!video.videoWidth || !video.videoHeight) return resolve(null);
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return resolve(null);
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            canvas.toBlob(resolve, 'image/jpeg', .92);
        });
    }
    public async editCurrentDetectorFrame() {
        if (!this.currentDetectorFrameEditReady()) return;
        const video = document.getElementById('human-label-image') as HTMLVideoElement;
        if (!video || video.tagName !== 'VIDEO' || !video.paused) return;
        this.videoFramePreparing = true;
        this.errorMessage = '';
        this.notice = '';
        await this.service.render();
        try {
            const frame = await this.capturePausedVideoFrame(video);
            if (!frame) throw new Error('현재 동영상 화면을 Bucky 수정 프레임으로 준비하지 못했습니다.');
            const timeSeconds = Number(video.currentTime || this.videoCurrentTime);
            const matchingLivePolygon = (
                Math.abs(this.liveInferenceSourceTime - timeSeconds) <= .25
                && this.buckyPolygonPoints(this.liveDetectorPolygon).length === 4
            ) ? this.liveDetectorPolygon : null;
            const matchingRawPolygon = (
                Math.abs(this.liveInferenceSourceTime - timeSeconds) <= .25
                && this.buckyPolygonPoints(this.liveDetectorRawPolygon).length === 4
            ) ? this.liveDetectorRawPolygon : null;
            const polygon = matchingLivePolygon || this.draft?.bucky_polygon;
            if (this.buckyPolygonPoints(polygon).length !== 4) {
                throw new Error('현재 프레임에서 Bucky를 찾지 못했습니다. 대표 프레임 좌표를 먼저 지정해 주세요.');
            }
            this.pendingVideoFrame = {
                blob: frame,
                imageId: String(this.current?.image_id || ''),
                timeSeconds,
                rawPolygon: JSON.parse(JSON.stringify(matchingRawPolygon || polygon)),
                originalDraft: JSON.parse(JSON.stringify(this.draft || {})),
            };
            this.draft.bucky_polygon = JSON.parse(JSON.stringify(polygon));
            this.draft.bucky_visibility = 'VISIBLE';
            this.draft.equipment_gt_origin = 'CURRENT_VIDEO_FRAME';
            this.videoCurrentTime = timeSeconds;
            this.videoEditingCurrentFrame = true;
            this.gtCaptureMode = false;
            this.resetEquipmentChecklist();
            this.syncBuckyBbox();
            this.markCorrected();
            this.notice = `현재 ${timeSeconds.toFixed(1)}초 화면의 Bucky를 조정한 뒤 ‘현재 프레임 라벨 저장’만 누르면 GT 확정과 저장이 함께 처리됩니다.`;
        } catch (error: any) {
            this.errorMessage = error?.message || '현재 동영상 프레임 편집을 시작하지 못했습니다.';
        }
        this.videoFramePreparing = false;
        await this.service.render();
        setTimeout(() => this.updateImageMetrics(), 0);
    }
    public cancelCurrentDetectorFrameEdit(render = true) {
        if (this.pendingVideoFrame?.originalDraft) {
            this.draft = JSON.parse(JSON.stringify(this.pendingVideoFrame.originalDraft));
            this.equipmentChecklist = {
                outerEdges: Boolean(this.draft?.equipment_gt_checklist?.outer_edges),
                occludedEdges: Boolean(this.draft?.equipment_gt_checklist?.occluded_edges),
                personIndependent: Boolean(this.draft?.equipment_gt_checklist?.person_independent),
            };
        }
        this.pendingVideoFrame = null;
        this.videoEditingCurrentFrame = false;
        this.videoFramePreparing = false;
        this.gtCaptureMode = false;
        if (render) this.service.render();
    }
    private syncVideoPosition(video: HTMLVideoElement) {
        this.videoCurrentTime = Number(video.currentTime || 0);
        this.videoAtReviewFrame = Math.abs(this.videoCurrentTime - this.reviewFrameTime()) <= .05;
        this.service.render();
    }
    private startLiveInference(video: HTMLVideoElement) {
        this.stopLiveInference(false);
        const generation = this.liveInferenceGeneration;
        const tick = async () => {
            if (generation !== this.liveInferenceGeneration || video.paused || video.ended) return;
            await this.inferLiveVideoFrame(video, generation);
            if (generation !== this.liveInferenceGeneration || video.paused || video.ended) return;
            this.liveInferenceTimer = setTimeout(tick, this.liveInferenceDelayMs);
        };
        void tick();
    }
    private stopLiveInference(clear: boolean) {
        this.liveInferenceGeneration += 1;
        if (this.liveInferenceTimer) clearTimeout(this.liveInferenceTimer);
        this.liveInferenceTimer = null;
        this.liveInferenceBusy = false;
        if (!clear) return;
        this.liveDetectorPolygon = null;
        this.liveDetectorRawPolygon = null;
        this.liveInferenceCount = 0;
        this.liveDetectionCount = 0;
        this.liveMovementEvents = 0;
        this.liveMaxCenterShift = 0;
        this.liveStartSeconds = 0;
        this.liveEndSeconds = 0;
        this.liveInferenceError = '';
        this.liveInferenceSourceTime = -1;
        this.liveAppliedBoxSource = 'AI_PREDICTION';
        this.liveAnchorDriftScore = 0;
        this.liveMissStreak = 0;
        this.livePreviousCenter = null;
        this.liveFirstCenter = null;
    }
    private async inferLiveVideoFrame(video: HTMLVideoElement, generation: number) {
        if (this.liveInferenceBusy || video.readyState < 2 || !video.videoWidth) return;
        const canvas = document.getElementById('bucky-reaudit-live-canvas') as HTMLCanvasElement;
        if (!canvas) return;
        const scale = Math.min(1, this.liveCaptureMaxWidth / video.videoWidth);
        canvas.width = Math.max(1, Math.round(video.videoWidth * scale));
        canvas.height = Math.max(1, Math.round(video.videoHeight * scale));
        const context = canvas.getContext('2d');
        if (!context) return;
        const sourceTime = Number(video.currentTime || 0);
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        const blob = await new Promise<Blob | null>(resolve => canvas.toBlob(resolve, 'image/jpeg', .86));
        if (!blob || generation !== this.liveInferenceGeneration) return;
        this.liveInferenceBusy = true;
        try {
            const form = new FormData();
            form.append('image', blob, 'bucky-video-frame.jpg');
            form.append('realtime', '1');
            form.append('tracking_id', this.liveTrackingId);
            const response = await fetch('/wiz/api/page.xray/analyze_v2', {
                method: 'POST', body: form, credentials: 'same-origin',
            });
            const payload = await response.json();
            if (generation !== this.liveInferenceGeneration) return;
            const data = payload?.data || {};
            this.liveInferenceSourceTime = sourceTime;
            const detector = data?.bucky_detection || data?.bucky || data?.detector || {};
            const corners = detector?.corners || detector?.detector_config?.corners
                || detector?.bucky_bbox || data?.bucky_bbox || null;
            const rawPolygon = corners && BUCKY_CORNERS.every(name => corners[name])
                ? JSON.parse(JSON.stringify(corners)) : null;
            const polygon = rawPolygon ? this.applyVideoBuckyAnchor(rawPolygon, sourceTime) : null;
            this.liveInferenceCount += 1;
            this.liveStartSeconds = this.liveInferenceCount === 1 ? sourceTime : Math.min(this.liveStartSeconds, sourceTime);
            this.liveEndSeconds = Math.max(this.liveEndSeconds, sourceTime);
            if (polygon) {
                this.liveMissStreak = 0;
                this.liveDetectionCount += 1;
                this.liveDetectorRawPolygon = rawPolygon;
                this.liveDetectorPolygon = polygon;
                this.liveAppliedBoxSource = this.videoBuckyTrackingAnchor(sourceTime)
                    ? 'USER_GT_TRACKED' : 'AI_PREDICTION';
                this.liveAnchorDriftScore = this.videoAnchorShapeDrift(rawPolygon, sourceTime);
                const points = this.buckyPolygonPoints(polygon);
                const center = {
                    x: points.reduce((sum, point) => sum + Number(point.x), 0) / 4,
                    y: points.reduce((sum, point) => sum + Number(point.y), 0) / 4,
                };
                if (!this.liveFirstCenter) this.liveFirstCenter = center;
                if (this.livePreviousCenter) {
                    const step = Math.hypot(center.x - this.livePreviousCenter.x, center.y - this.livePreviousCenter.y);
                    if (step >= .007) this.liveMovementEvents += 1;
                }
                this.liveMaxCenterShift = Math.max(
                    this.liveMaxCenterShift,
                    Math.hypot(center.x - this.liveFirstCenter.x, center.y - this.liveFirstCenter.y),
                );
                this.livePreviousCenter = center;
                this.liveInferenceError = '';
            } else {
                this.liveDetectorRawPolygon = null;
                this.liveMissStreak += 1;
                if (
                    this.liveDetectorPolygon
                    && this.liveMissStreak <= this.livePredictionHoldFrames
                    && this.videoBuckyAnchorActive()
                ) {
                    this.liveAppliedBoxSource = 'USER_GT_HOLD';
                    this.liveInferenceError = `현재 프레임 AI 미검출 · 직전 GT 추적 ${this.liveMissStreak}/${this.livePredictionHoldFrames}프레임 유지`;
                } else {
                    this.liveDetectorPolygon = null;
                    this.liveAppliedBoxSource = 'AI_PREDICTION';
                    this.liveInferenceError = '현재 프레임 Bucky 미검출 · 수동 수정이 필요합니다.';
                }
            }
            await this.service.render();
        } catch (_) {
            if (generation === this.liveInferenceGeneration) {
                this.liveInferenceError = '실시간 Bucky 추론 재시도 중';
                await this.service.render();
            }
        } finally {
            if (generation === this.liveInferenceGeneration) this.liveInferenceBusy = false;
        }
    }

    public onImageLoad() {
        const media = document.getElementById('human-label-image') as HTMLElement;
        if (media && !this.baseImageDisplay.width) {
            const rect = media.getBoundingClientRect();
            this.baseImageDisplay = { width: rect.width, height: rect.height };
            this.service.render();
        }
        setTimeout(() => this.updateImageMetrics(), 0);
    }

    public imageStageStyle() {
        const baseWidth = Number(this.baseImageDisplay.width || 0);
        const baseHeight = Number(this.baseImageDisplay.height || 0);
        if (!baseWidth || !baseHeight) return {};
        return {
            // Scale both axes from the same captured source rectangle. This
            // keeps Bucky-fit zoom from widening the media while a max-height
            // rule clamps only its vertical axis.
            width: `${baseWidth * this.zoomScale}px`,
            height: `${baseHeight * this.zoomScale}px`,
            aspectRatio: `${baseWidth} / ${baseHeight}`,
        };
    }

    public imageDisplayStyle() {
        return this.baseImageDisplay.width ? {
            width: '100%', height: '100%', maxWidth: 'none', maxHeight: 'none',
            objectFit: 'contain',
        } : {};
    }

    public zoomPercent() { return Math.round(this.zoomScale * 100); }

    public zoomBy(delta: number) {
        this.zoomMode = 'manual';
        this.applyZoom(Math.max(1, Math.min(3, this.zoomScale + delta)));
    }

    public resetZoom() {
        this.zoomMode = 'full';
        this.applyZoom(1, () => {
            const viewport = document.getElementById('image-zoom-viewport');
            if (viewport) { viewport.scrollLeft = 0; viewport.scrollTop = 0; }
        });
    }

    public focusUpperBody() {
        const ids = new Set([0, 11, 12, 13, 14, 15, 16, 23, 24]);
        const points = (this.draft?.pose_keypoints || []).filter(
            (point: any) => ids.has(Number(point.id))
                && this.isOperatingPosePointVisible(point)
        );
        this.zoomMode = 'upper';
        this.applyZoom(2, () => {
            const viewport = document.getElementById('image-zoom-viewport');
            if (!viewport) return;
            const fallback = {x: 0.5, top: 0.12};
            const focus = points.length ? {
                x: points.reduce((sum: number, point: any) => sum + Number(point.x), 0) / points.length,
                top: Math.max(0, Math.min(...points.map((point: any) => Number(point.y))) - 0.08),
            } : fallback;
            viewport.scrollLeft = Math.max(0, focus.x * viewport.scrollWidth - viewport.clientWidth / 2);
            viewport.scrollTop = Math.max(0, focus.top * viewport.scrollHeight);
        });
    }

    public focusBucky() {
        const box = this.draft?.bucky_bbox;
        if (!box) {
            this.errorMessage = 'Bucky 네 모서리를 먼저 지정해 주세요.';
            this.service.render();
            return;
        }
        this.errorMessage = '';
        this.zoomMode = 'bucky';
        this.applyZoom(2.5, () => {
            const viewport = document.getElementById('image-zoom-viewport');
            if (!viewport) return;
            const centerX = Number(box.x) + Number(box.width) / 2;
            const centerY = Number(box.y) + Number(box.height) / 2;
            viewport.scrollLeft = Math.max(0, centerX * viewport.scrollWidth - viewport.clientWidth / 2);
            viewport.scrollTop = Math.max(0, centerY * viewport.scrollHeight - viewport.clientHeight / 2);
        });
    }

    private applyZoom(scale: number, after?: () => void) {
        this.zoomScale = Number(scale.toFixed(2));
        this.service.render();
        setTimeout(() => {
            this.updateImageMetrics();
            if (after) after();
        }, 0);
    }

    public updateImageMetrics() {
        const media = document.getElementById('human-label-image') as any;
        if (!media) return;
        const rect = media.getBoundingClientRect();
        const naturalWidth = Number(media.naturalWidth || media.videoWidth || this.current?.image_size?.width || 0);
        const naturalHeight = Number(media.naturalHeight || media.videoHeight || this.current?.image_size?.height || 0);
        this.imageMetrics = {
            naturalWidth, naturalHeight,
            displayWidth: rect.width, displayHeight: rect.height,
            scaleX: rect.width ? naturalWidth / rect.width : 0,
            scaleY: rect.height ? naturalHeight / rect.height : 0,
        };
        this.service.render();
    }

    public bboxDebug() {
        const box = this.draft?.bucky_bbox; const metrics = this.imageMetrics;
        if (!box) return null;
        return {
            screen: {
                x: box.x * metrics.displayWidth, y: box.y * metrics.displayHeight,
                width: box.width * metrics.displayWidth, height: box.height * metrics.displayHeight,
            },
            original: {
                x: box.x * metrics.naturalWidth, y: box.y * metrics.naturalHeight,
                width: box.width * metrics.naturalWidth, height: box.height * metrics.naturalHeight,
            },
        };
    }

    public keypointDebug() {
        const point = this.selectedPoint(); const metrics = this.imageMetrics;
        if (!point) return null;
        return {
            id: point.id, name: this.pointName(point.id),
            screen: { x: point.x * metrics.displayWidth, y: point.y * metrics.displayHeight },
            original: { x: point.x * metrics.naturalWidth, y: point.y * metrics.naturalHeight },
        };
    }

    public bboxStyle() {
        const box = this.draft?.bucky_bbox;
        if (!box) return {};
        return { left: `${box.x * 100}%`, top: `${box.y * 100}%`, width: `${box.width * 100}%`, height: `${box.height * 100}%` };
    }

    public buckyMoveAreaStyle() {
        return this.bboxStyle();
    }

    public addBucky() {
        this.resetEquipmentChecklist();
        this.draft.bucky_polygon = null;
        this.draft.bucky_bbox = null;
        this.draft.bucky_visibility = 'VISIBLE';
        this.draft.equipment_gt_confirmed = false;
        this.draft.equipment_gt_origin = 'CURRENT_REVIEW';
        this.gtCaptureMode = true;
        this.gtCaptureIndex = 0;
        this.markCorrected();
        this.service.render();
    }

    public deleteBucky() {
        this.resetEquipmentChecklist();
        this.draft.bucky_bbox = null;
        this.draft.bucky_polygon = null;
        this.draft.bucky_visibility = 'NOT_VISIBLE';
        this.draft.equipment_gt_confirmed = false;
        this.draft.equipment_gt_origin = 'CURRENT_REVIEW';
        this.gtCaptureMode = false;
        this.draft.status = 'HUMAN_RELABELED'; this.draft.group = 'HARD_CASE';
        this.service.render();
    }

    public defineGtCorner(event: PointerEvent) {
        if (!this.gtCaptureMode || !this.showReviewCoordinates()) return;
        const point = this.coordinate(event);
        if (!point) return;
        this.resetEquipmentChecklist();
        const polygon = this.draft.bucky_polygon || {};
        polygon[BUCKY_CORNERS[this.gtCaptureIndex]] = point;
        this.draft.bucky_polygon = polygon;
        this.gtCaptureIndex += 1;
        if (this.gtCaptureIndex >= BUCKY_CORNERS.length) {
            this.gtCaptureMode = false;
            this.syncBuckyBbox();
        }
        this.markCorrected();
        this.service.render();
    }

    public buckyPolygonPoints(value: any = this.draft?.bucky_polygon) {
        if (!value) return [];
        return BUCKY_CORNERS
            .map(name => ({ name, ...(value[name] || {}) }))
            .filter(point => Number.isFinite(Number(point.x)) && Number.isFinite(Number(point.y)));
    }

    public buckyPolygonString(value: any) {
        return this.buckyPolygonPoints(value)
            .map(point => `${Number(point.x)},${Number(point.y)}`).join(' ');
    }

    public loadHistoricalManualGt() {
        const polygon = this.current?.historical_manual_gt?.polygon;
        if (this.buckyPolygonPoints(polygon).length !== 4) {
            this.errorMessage = '재사용할 수 있는 기존 수동 Bucky 네 모서리가 없습니다.';
            this.service.render();
            return;
        }
        this.resetEquipmentChecklist();
        this.draft.bucky_polygon = JSON.parse(JSON.stringify(polygon));
        this.draft.bucky_visibility = 'VISIBLE';
        this.draft.equipment_gt_confirmed = false;
        this.draft.equipment_gt_origin = 'HISTORICAL_USER_MANUAL_CORRECTION';
        this.gtCaptureMode = false;
        this.syncBuckyBbox();
        this.markCorrected();
        this.notice = '기존에 직접 지정한 네 모서리를 불러왔습니다. 현재 장비 최외곽과 맞는지 확인 후 GT를 확정하세요.';
        this.errorMessage = '';
        this.service.render();
        setTimeout(() => this.focusBucky(), 0);
    }

    public beginBuckyCorner(event: PointerEvent, name: string) {
        event.preventDefault(); event.stopPropagation();
        if (!BUCKY_CORNERS.includes(name)) return;
        this.dragMode = 'bucky-corner';
        this.dragHandle = name;
        this.resetEquipmentChecklist();
        this.draft.equipment_gt_confirmed = false;
    }

    public beginBuckyMove(event: PointerEvent) {
        event.preventDefault(); event.stopPropagation();
        const coordinate = this.coordinate(event);
        const polygon = this.draft?.bucky_polygon;
        if (!coordinate || this.buckyPolygonPoints(polygon).length !== 4) return;
        this.dragMode = 'bucky-move';
        this.dragStart = {
            coordinate,
            polygon: JSON.parse(JSON.stringify(polygon)),
        };
        this.resetEquipmentChecklist();
        this.draft.equipment_gt_confirmed = false;
    }

    private syncBuckyBbox() {
        const points = this.buckyPolygonPoints();
        if (points.length !== 4) { this.draft.bucky_bbox = null; return; }
        const xs = points.map(point => Number(point.x));
        const ys = points.map(point => Number(point.y));
        this.draft.bucky_bbox = {
            x: Math.min(...xs), y: Math.min(...ys),
            width: Math.max(...xs) - Math.min(...xs),
            height: Math.max(...ys) - Math.min(...ys),
        };
    }

    public transformBucky(rotationDeg = 0, widthScale = 1, heightScale = 1) {
        const points = this.buckyPolygonPoints();
        if (points.length !== 4) return;
        this.resetEquipmentChecklist();
        const center = {
            x: points.reduce((sum, point) => sum + Number(point.x), 0) / 4,
            y: points.reduce((sum, point) => sum + Number(point.y), 0) / 4,
        };
        const radians = rotationDeg * Math.PI / 180;
        const cosine = Math.cos(radians), sine = Math.sin(radians);
        for (const point of points) {
            const dx = (Number(point.x) - center.x) * widthScale;
            const dy = (Number(point.y) - center.y) * heightScale;
            this.draft.bucky_polygon[point.name] = {
                x: Math.max(0, Math.min(1, center.x + dx * cosine - dy * sine)),
                y: Math.max(0, Math.min(1, center.y + dx * sine + dy * cosine)),
            };
        }
        this.draft.equipment_gt_confirmed = false;
        this.syncBuckyBbox(); this.markCorrected(); this.service.render();
    }

    public confirmEquipmentGt(render = true) {
        if (this.buckyPolygonPoints().length !== 4) {
            this.errorMessage = '실제 장비 전면 패널의 네 모서리를 모두 지정해 주세요.';
            if (render) this.service.render();
            return false;
        }
        // The single GT action is the user's acknowledgement of all criteria.
        // Keep the structured checklist in the saved label without forcing
        // three separate checkboxes in the primary review flow.
        this.equipmentChecklist = {
            outerEdges: true,
            occludedEdges: true,
            personIndependent: true,
        };
        if (this.humanSimilarityWarning()) {
            this.errorMessage = '사람 몸통과 지나치게 유사한 Bucky GT는 확정할 수 없습니다. 장비 전면 패널 외곽을 다시 지정해 주세요.';
            if (render) this.service.render();
            return false;
        }
        this.draft.equipment_gt_confirmed = true;
        this.draft.bucky_visibility = this.draft.bucky_visibility === 'PARTIAL' ? 'PARTIAL' : 'VISIBLE';
        this.draft.equipment_gt_checklist = this.equipmentChecklistPayload();
        this.errorMessage = '';
        this.notice = '장비 GT 네 모서리를 확정했습니다.';
        this.markCorrected();
        if (render) this.service.render();
        return true;
    }

    private resetEquipmentChecklist() {
        this.equipmentChecklist = {
            outerEdges: false,
            occludedEdges: false,
            personIndependent: false,
        };
        if (this.draft) {
            this.draft.equipment_gt_confirmed = false;
            this.draft.equipment_gt_checklist = this.equipmentChecklistPayload();
        }
    }

    public equipmentChecklistComplete() {
        return Boolean(
            this.equipmentChecklist.outerEdges
            && this.equipmentChecklist.occludedEdges
            && this.equipmentChecklist.personIndependent
        );
    }

    public setEquipmentChecklist(key: 'outerEdges' | 'occludedEdges' | 'personIndependent', checked: boolean) {
        this.equipmentChecklist = {
            ...this.equipmentChecklist,
            [key]: Boolean(checked),
        };
        if (this.draft) {
            this.draft.equipment_gt_checklist = this.equipmentChecklistPayload();
            if (!this.equipmentChecklistComplete()) this.draft.equipment_gt_confirmed = false;
        }
        this.errorMessage = '';
        this.service.render();
    }

    public selectAllEquipmentChecklist() {
        this.equipmentChecklist = {
            outerEdges: true,
            occludedEdges: true,
            personIndependent: true,
        };
        if (this.draft) {
            this.draft.equipment_gt_checklist = this.equipmentChecklistPayload();
            this.draft.equipment_gt_confirmed = false;
        }
        this.errorMessage = '';
        this.service.render();
    }

    public canConfirmEquipmentGt() {
        return this.buckyPolygonPoints().length === 4
            && !this.humanSimilarityWarning();
    }

    public toggleEquipmentChecklistDetails() {
        this.equipmentChecklistDetailsOpen = !this.equipmentChecklistDetailsOpen;
        this.service.render();
    }

    public equipmentChecklistPayload() {
        return {
            outer_edges: Boolean(this.equipmentChecklist.outerEdges),
            occluded_edges: Boolean(this.equipmentChecklist.occludedEdges),
            person_independent: Boolean(this.equipmentChecklist.personIndependent),
        };
    }

    public beginBbox(event: PointerEvent, mode: 'move' | 'resize', handle = '') {
        event.preventDefault(); event.stopPropagation();
        const coordinate = this.coordinate(event); const box = this.draft?.bucky_bbox;
        if (!coordinate || !box) return;
        this.dragMode = mode === 'move' ? 'bbox-move' : 'bbox-resize'; this.dragHandle = handle;
        this.dragStart = { coordinate, box: {...box} };
    }

    public beginPose(event: PointerEvent, id: number) {
        event.preventDefault(); event.stopPropagation();
        this.gtCaptureMode = false;
        this.selectedPointId = id; this.dragMode = 'pose'; this.dragPointId = id;
        this.updatePoseFromEvent(event);
    }

    private coordinate(event: PointerEvent) {
        if (!this.showReviewCoordinates()) return null;
        const media = document.getElementById('human-label-image') as HTMLElement;
        if (!media) return null;
        const rect = media.getBoundingClientRect();
        if (!rect.width || !rect.height) return null;
        return { x: Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width)), y: Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height)) };
    }

    private onPointerMove(event: PointerEvent) {
        if (!this.dragMode) return;
        if (this.dragMode === 'pose') { this.updatePoseFromEvent(event); return; }
        if (this.dragMode === 'bucky-corner') {
            const point = this.coordinate(event);
            if (!point || !this.draft?.bucky_polygon?.[this.dragHandle]) return;
            this.draft.bucky_polygon[this.dragHandle] = point;
            this.syncBuckyBbox(); this.markCorrected(); this.service.render();
            return;
        }
        if (this.dragMode === 'bucky-move') {
            const point = this.coordinate(event);
            const start = this.dragStart;
            if (!point || !start?.polygon) return;
            const dx = point.x - start.coordinate.x;
            const dy = point.y - start.coordinate.y;
            const original = this.buckyPolygonPoints(start.polygon);
            const minX = Math.min(...original.map(item => Number(item.x)));
            const maxX = Math.max(...original.map(item => Number(item.x)));
            const minY = Math.min(...original.map(item => Number(item.y)));
            const maxY = Math.max(...original.map(item => Number(item.y)));
            const safeDx = Math.max(-minX, Math.min(1 - maxX, dx));
            const safeDy = Math.max(-minY, Math.min(1 - maxY, dy));
            for (const item of original) {
                this.draft.bucky_polygon[item.name] = {
                    x: Number(item.x) + safeDx,
                    y: Number(item.y) + safeDy,
                };
            }
            this.syncBuckyBbox(); this.markCorrected(); this.service.render();
            return;
        }
        const point = this.coordinate(event); const start = this.dragStart;
        if (!point || !start) return;
        let {x, y, width, height} = start.box;
        const dx = point.x - start.coordinate.x, dy = point.y - start.coordinate.y;
        if (this.dragMode === 'bbox-move') {
            x = Math.max(0, Math.min(1 - width, x + dx)); y = Math.max(0, Math.min(1 - height, y + dy));
        } else {
            if (this.dragHandle.includes('l')) { const right = x + width; x = Math.max(0, Math.min(right - 0.01, x + dx)); width = right - x; }
            if (this.dragHandle.includes('r')) width = Math.max(0.01, Math.min(1 - x, width + dx));
            if (this.dragHandle.includes('t')) { const bottom = y + height; y = Math.max(0, Math.min(bottom - 0.01, y + dy)); height = bottom - y; }
            if (this.dragHandle.includes('b')) height = Math.max(0.01, Math.min(1 - y, height + dy));
        }
        this.draft.bucky_bbox = {x, y, width, height}; this.markCorrected(); this.service.render();
    }

    private updatePoseFromEvent(event: PointerEvent) {
        const coordinate = this.coordinate(event); const point = this.posePoint(this.dragPointId);
        if (!coordinate || !point) return;
        point.x = coordinate.x; point.y = coordinate.y; point.visibility = 'visible';
        this.markCorrected(); this.service.render();
    }

    private endDrag() { this.dragMode = ''; this.dragHandle = ''; this.dragPointId = -1; this.dragStart = null; }

    public personBbox() {
        const rows = (this.draft?.pose_keypoints || []).filter(
            (point: any) => this.isOperatingPosePointVisible(point)
        );
        if (rows.length < 2) return null;
        const xs = rows.map((point: any) => Number(point.x));
        const ys = rows.map((point: any) => Number(point.y));
        return {
            x: Math.min(...xs), y: Math.min(...ys),
            width: Math.max(...xs) - Math.min(...xs),
            height: Math.max(...ys) - Math.min(...ys),
        };
    }

    public personBboxStyle() {
        const box = this.personBbox();
        if (!box) return {};
        return {
            left: `${box.x * 100}%`, top: `${box.y * 100}%`,
            width: `${box.width * 100}%`, height: `${box.height * 100}%`,
        };
    }

    public humanSimilarityWarning() {
        const bucky = this.draft?.bucky_bbox;
        const person = this.personBbox();
        if (!bucky || !person) return false;
        const right = (box: any) => Number(box.x) + Number(box.width);
        const bottom = (box: any) => Number(box.y) + Number(box.height);
        const intersection = Math.max(0, Math.min(right(bucky), right(person)) - Math.max(bucky.x, person.x))
            * Math.max(0, Math.min(bottom(bucky), bottom(person)) - Math.max(bucky.y, person.y));
        const union = bucky.width * bucky.height + person.width * person.height - intersection;
        return union > 0 && intersection / union >= 0.72;
    }

    public setBuckyVisibility(value: string) {
        // The legacy "판정 불가" button used NOT_VISIBLE. Keep its meaning as
        // unavailable/excluded; only the explicit Hard negative action below
        // may create a trainable empty Bucky label.
        if (value === 'NOT_VISIBLE') value = 'UNAVAILABLE';
        this.resetEquipmentChecklist();
        this.draft.bucky_visibility = value;
        if (value === 'NOT_VISIBLE' || value === 'UNAVAILABLE') {
            this.draft.bucky_bbox = null;
            this.draft.bucky_polygon = null;
            this.draft.equipment_gt_confirmed = false;
            this.gtCaptureMode = false;
            this.draft.status = 'EXCLUDED';
            this.draft.group = 'EXCLUDED';
        }
        this.service.render();
    }

    public confirmHardNegative() {
        this.resetEquipmentChecklist();
        this.draft.bucky_visibility = 'NOT_VISIBLE';
        this.draft.bucky_bbox = null;
        this.draft.bucky_polygon = null;
        this.draft.equipment_gt_confirmed = false;
        this.draft.equipment_gt_origin = 'HUMAN_CONFIRMED_NO_BUCKY';
        this.gtCaptureMode = false;
        this.draft.status = 'HUMAN_RELABELED';
        this.draft.group = 'HARD_CASE';
        this.notice = '사진에 실제 Bucky 장비가 없음을 Hard negative로 지정했습니다.';
        this.service.render();
    }

    public detectorReviewReady() {
        if (!this.detectorOnlyMode) return true;
        if (this.videoEditingCurrentFrame) return this.canConfirmEquipmentGt();
        const staticReviewReady = this.draft?.equipment_gt_confirmed === true
            || ['NOT_VISIBLE', 'UNAVAILABLE'].includes(
                String(this.draft?.bucky_visibility || '').toUpperCase()
            );
        return staticReviewReady && (
            !this.videoAvailable()
            || this.liveInferenceCount >= 3
            || this.videoEditingCurrentFrame
            || this.draft?.equipment_gt_origin === 'CURRENT_VIDEO_FRAME'
        );
    }

    private markCorrected() {
        // Paused-frame corner edits are frame-level GT work.  They must not
        // mutate the queue item's final review decision; only save(true),
        // exposed as "Bucky 저장 후 다음", may do that.
        if (this.videoEditingCurrentFrame) return;
        if (this.draft.status === 'AUTO_ACCEPTED') this.draft.status = 'HUMAN_CORRECTED';
        if (this.draft.group === 'NORMAL') this.draft.group = 'CORRECTION';
    }

    public posePoint(id: number) { return (this.draft?.pose_keypoints || [])[id]; }
    public posePoints() {
        const rows = this.draft?.pose_keypoints || [];
        return this.showAllPoints ? rows : rows.filter((row: any) => PRIORITY_IDS.has(Number(row.id)));
    }
    public togglePoseMode() {
        this.showAllPoints = !this.showAllPoints;
        if (!this.showAllPoints && !this.isPriority(this.selectedPointId)) {
            this.selectedPointId = 11;
        }
        this.service.render();
    }
    public selectPoint(id: number) {
        this.selectedPointId = Number(id);
        this.service.render();
    }
    public isOperatingPosePointVisible(point: any) {
        const x = Number(point?.x), y = Number(point?.y);
        return point?.visibility !== 'not_labeled'
            && Number.isFinite(x) && Number.isFinite(y)
            && x >= 0 && x <= 1 && y >= 0 && y <= 1
            && !(x === 0 && y === 0);
    }
    public isPosePointRendered(point: any) {
        return this.isOperatingPosePointVisible(point)
            && (
                (
                    point?.visibility !== 'occluded'
                    && !this.isAutoOccludedWrist(point)
                )
                || Number(point?.id) === this.selectedPointId
            );
    }
    public isAutoOccludedWrist(point: any) {
        const id = Number(point?.id);
        const supportIds = id === 15 ? [17, 19, 21] : id === 16 ? [18, 20, 22] : [];
        if (!supportIds.length || Number(this.draft?.version || 0) > 0) return false;
        const autoPoint = (this.current?.auto?.pose_keypoints || [])[id];
        if (
            !autoPoint
            || Math.abs(Number(point?.x) - Number(autoPoint.x)) > 0.000001
            || Math.abs(Number(point?.y) - Number(autoPoint.y)) > 0.000001
        ) return false;
        const handSupport = Math.max(...supportIds.map(
            supportId => Number((this.current?.auto?.pose_keypoints || [])[supportId]?.confidence || 0)
        ));
        if (handSupport >= 0.2) return false;
        const armIds = id === 15 ? [11, 13] : [12, 14];
        const shoulder = (this.current?.auto?.pose_keypoints || [])[armIds[0]];
        const elbow = (this.current?.auto?.pose_keypoints || [])[armIds[1]];
        if (shoulder && elbow) {
            const distance = (from: any, to: any) => Math.hypot(
                Number(to.x) - Number(from.x),
                Number(to.y) - Number(from.y)
            );
            const upperArm = distance(shoulder, elbow);
            const forearm = distance(elbow, point);
            const forearmRatio = upperArm > 0.000001 ? forearm / upperArm : 0;
            if (forearmRatio >= 0.55 && forearmRatio <= 1.8) return false;
        }
        const bucky = this.draft?.bucky_bbox || this.current?.auto?.bucky_bbox;
        if (!bucky) return false;
        const x = Number(point.x), y = Number(point.y);
        return x >= Number(bucky.x) - 0.05
            && x <= Number(bucky.x) + Number(bucky.width) + 0.05
            && y >= Number(bucky.y) - 0.02
            && y <= Number(bucky.y) + Number(bucky.height) + 0.08;
    }
    public poseOverlayPointIds() {
        if (!this.showAllPoints) return new Set(Array.from(PRIORITY_IDS));
        return new Set(
            XRAY_OPERATING_POSE_CONNECTIONS.flatMap(
                pair => [Number(pair[0]), Number(pair[1])]
            )
        );
    }
    public operatingPosePoints() {
        const ids = this.poseOverlayPointIds();
        return (this.draft?.pose_keypoints || []).filter(
            (point: any) => ids.has(Number(point.id))
                && this.isPosePointRendered(point)
        );
    }
    public visiblePosePoints() {
        return this.posePoints().filter(
            (point: any) => this.isPosePointRendered(point)
        );
    }
    public skeletonEdges() {
        const ids = this.poseOverlayPointIds();
        return XRAY_OPERATING_POSE_CONNECTIONS.map(([fromId, toId]) => ({
            fromId,
            toId,
            from: this.posePoint(Number(fromId)),
            to: this.posePoint(Number(toId)),
        })).filter(
            (edge: any) => ids.has(Number(edge.fromId))
                && ids.has(Number(edge.toId))
                && this.isPosePointRendered(edge.from)
                && this.isPosePointRendered(edge.to)
        );
    }
    public skeletonEdgeOccluded(edge: any) {
        return edge?.from?.visibility === 'occluded'
            || edge?.to?.visibility === 'occluded';
    }
    public skeletonEdgeStroke(edge: any) {
        return this.skeletonEdgeOccluded(edge)
            ? '#7dd3fc'
            : this.operatingPoseStyle.line;
    }
    public operatingPointFill(point: any) {
        return this.operatingPoseStyle.point;
    }
    public pointName(id: number) { return KO_NAMES[id] || `관절 ${id}`; }
    public isPriority(id: number) { return PRIORITY_IDS.has(Number(id)); }
    public isLowConfidence(point: any) {
        const auto = (this.current?.auto?.pose_keypoints || [])[Number(point?.id)];
        return Number(auto?.confidence || 0) < 0.5;
    }
    public pointStyle(point: any) { return { left: `${Number(point.x) * 100}%`, top: `${Number(point.y) * 100}%` }; }
    public selectedPointLabelStyle(point: any) {
        return {
            left: `${Number(point.x) * 100}%`,
            top: `${Number(point.y) * 100}%`,
            transform: 'translate(12px, -32px)',
        };
    }
    public selectedPoint() { return this.posePoint(this.selectedPointId); }
    public selectedVisiblePoint() {
        const point = this.selectedPoint();
        return this.isPosePointRendered(point) ? point : null;
    }

    public setVisibility(value: string) {
        const point = this.selectedPoint(); if (!point) return;
        point.visibility = value; this.markCorrected(); this.service.render();
    }

    public derivedPoint(kind: 'torso' | 'neck') {
        const midpoint = (a: any, b: any) => a && b ? {x: (Number(a.x) + Number(b.x)) / 2, y: (Number(a.y) + Number(b.y)) / 2} : null;
        const shoulders = midpoint(this.posePoint(11), this.posePoint(12));
        if (kind === 'neck') return shoulders;
        const hips = midpoint(this.posePoint(23), this.posePoint(24));
        return shoulders && hips ? midpoint(shoulders, hips) : shoulders;
    }

    public acceptAuto() {
        this.resetEquipmentChecklist();
        this.draft.bucky_bbox = JSON.parse(JSON.stringify(this.current?.auto?.bucky_bbox || null));
        this.draft.bucky_polygon = JSON.parse(JSON.stringify(this.current?.auto?.bucky_polygon || null));
        this.draft.bucky_visibility = this.draft.bucky_polygon ? 'VISIBLE' : 'UNAVAILABLE';
        this.draft.equipment_gt_confirmed = false;
        this.draft.equipment_gt_origin = 'MODEL_PREDICTION';
        this.draft.pose_keypoints = JSON.parse(JSON.stringify(this.current?.auto?.pose_keypoints || []));
        this.draft.status = 'AUTO_ACCEPTED'; this.draft.group = 'NORMAL';
        this.service.render();
    }
    public setStatus(value: string) {
        if (value === 'AUTO_ACCEPTED') { this.acceptAuto(); return; }
        this.draft.status = value;
        if (value === 'HUMAN_CORRECTED' && this.draft.group === 'NORMAL') this.draft.group = 'CORRECTION';
        else if (value === 'HUMAN_RELABELED') this.draft.group = 'HARD_CASE';
        else if (value === 'EXCLUDED') this.draft.group = 'EXCLUDED';
        this.service.render();
    }
    public setGroup(value: string) {
        this.draft.group = value;
        if (value === 'EXCLUDED') this.draft.status = 'EXCLUDED';
        else if (this.draft.status === 'EXCLUDED') this.draft.status = value === 'NORMAL' ? 'AUTO_ACCEPTED' : 'HUMAN_CORRECTED';
        this.service.render();
    }

    private normalizedRoundtripError(expected: any, reloaded: any) {
        let maximum = 0;
        const firstBox = expected?.bucky_bbox, secondBox = reloaded?.bucky_bbox;
        if (firstBox || secondBox) {
            if (!firstBox || !secondBox) maximum = 1;
            else for (const key of ['x', 'y', 'width', 'height']) maximum = Math.max(maximum, Math.abs(Number(firstBox[key]) - Number(secondBox[key])));
        }
        const firstPolygon = expected?.bucky_polygon, secondPolygon = reloaded?.bucky_polygon;
        if (firstPolygon || secondPolygon) {
            if (!firstPolygon || !secondPolygon) maximum = 1;
            else for (const name of BUCKY_CORNERS) for (const axis of ['x', 'y']) {
                maximum = Math.max(
                    maximum,
                    Math.abs(Number(firstPolygon[name]?.[axis]) - Number(secondPolygon[name]?.[axis]))
                );
            }
        }
        const firstPose = expected?.pose_keypoints || [], secondPose = reloaded?.pose_keypoints || [];
        if (firstPose.length !== secondPose.length) maximum = 1;
        else for (let index = 0; index < firstPose.length; index++) {
            maximum = Math.max(maximum, Math.abs(Number(firstPose[index].x) - Number(secondPose[index].x)), Math.abs(Number(firstPose[index].y) - Number(secondPose[index].y)));
            if (firstPose[index].visibility !== secondPose[index].visibility) maximum = 1;
        }
        return maximum;
    }

    private async reloadAndVerify(expected: any, serverCheck: any, validationOnly = false, imageId = '') {
        const targetImageId = imageId || this.current.image_id;
        const { code, data } = await this.loadReviewDetail(targetImageId, validationOnly);
        if (code !== 200) throw new Error(data?.message || '저장 후 재조회에 실패했습니다.');
        const reloaded = data?.item;
        const clientError = this.normalizedRoundtripError(expected, reloaded?.draft);
        this.current = reloaded;
        this.draft = JSON.parse(JSON.stringify(reloaded?.draft || {}));
        await this.service.render();
        this.updateImageMetrics();
        const maxDisplay = Math.max(Number(this.imageMetrics.displayWidth || 0), Number(this.imageMetrics.displayHeight || 0));
        const maxOriginal = Math.max(Number(this.imageMetrics.naturalWidth || 0), Number(this.imageMetrics.naturalHeight || 0));
        this.roundtripCheck = {
            status: serverCheck?.status === 'PASS' && clientError <= 1e-8 ? 'PASS' : 'FAIL',
            serverNormalizedError: Number(serverCheck?.normalized_max_error ?? 1),
            clientNormalizedError: clientError,
            screenPixelError: clientError * maxDisplay,
            originalPixelError: clientError * maxOriginal,
            version: Number(this.draft?.version || 0),
        };
        await this.service.render();
    }

    private async removeSavedItemAndOpenNext() {
        const savedIndex = this.currentIndex;
        this.items.splice(savedIndex, 1);
        if (!this.items.length) {
            this.currentIndex = 0;
            this.current = null;
            this.draft = null;
            return;
        }
        this.currentIndex = Math.min(savedIndex, this.items.length - 1);
        await this.openCurrent(false);
    }

    private detectorReviewPayload() {
        return {
            status: this.draft.status, group: this.draft.group,
            exclusion_reason: this.draft.exclusion_reason || '',
            bucky_bbox: this.draft.bucky_bbox,
            bucky_polygon: this.draft.bucky_polygon,
            bucky_visibility: this.draft.bucky_visibility,
            equipment_gt_confirmed: this.draft.equipment_gt_confirmed,
            equipment_gt_checklist: this.equipmentChecklistPayload(),
            equipment_gt_origin: this.draft.equipment_gt_origin || 'CURRENT_REVIEW',
            temporal_validation: this.temporalValidationPayload(),
            video_tracking_anchor: this.pendingVideoFrame?.rawPolygon ? {
                source_video_sha256: String(this.current?.media?.source_video_sha256 || ''),
                timestamp_seconds: Number(this.pendingVideoFrame.timeSeconds || 0),
                raw_polygon: this.pendingVideoFrame.rawPolygon,
                corrected_polygon: this.draft.bucky_polygon,
            } : (this.current?.media?.video_tracking_anchor || null),
            pose_keypoints: this.draft.pose_keypoints,
        };
    }

    private detectorFrameReviewPayload() {
        const payload = this.detectorReviewPayload();
        return {
            // These values describe the saved frame GT label, not completion
            // of the parent video review item.
            status: 'HUMAN_CORRECTED',
            group: 'CORRECTION',
            bucky_polygon: payload.bucky_polygon,
            equipment_gt_confirmed: payload.equipment_gt_confirmed,
            equipment_gt_checklist: payload.equipment_gt_checklist,
            video_tracking_anchor: payload.video_tracking_anchor,
        };
    }

    public async saveCurrentDetectorFrame() {
        if (!this.current || this.saving || !this.videoEditingCurrentFrame || !this.pendingVideoFrame?.blob) return;
        // A paused-frame correction is one action: validate the edited box,
        // confirm it as GT, and persist the frame label together.
        if (!this.confirmEquipmentGt(false)) {
            await this.service.render();
            return;
        }
        if (!this.detectorReviewReady()) {
            this.errorMessage = '현재 프레임 Bucky 좌표를 확인한 뒤 다시 저장해 주세요.';
            await this.service.render();
            return;
        }
        this.saving = true;
        this.errorMessage = '';
        this.notice = '';
        const expected = JSON.parse(JSON.stringify({
            bucky_bbox: this.draft.bucky_bbox,
            bucky_polygon: this.draft.bucky_polygon,
            pose_keypoints: this.draft.pose_keypoints,
        }));
        await this.service.render();
        try {
            // WIZ exposes multipart files through request.file(), while the
            // textual request metadata is read through request.query(). Keep
            // only the JPEG in FormData and send the compact GT metadata in
            // the query string so the request reaches the frame-GT branch.
            const query = new URLSearchParams();
            query.set('operation', 'save_detector_video_frame_draft');
            query.set('image_id', this.pendingVideoFrame.imageId || this.current.image_id);
            query.set('time_seconds', String(this.pendingVideoFrame.timeSeconds));
            query.set('review', JSON.stringify(this.detectorFrameReviewPayload()));
            const form = new FormData();
            form.append('frame', this.pendingVideoFrame.blob, 'bucky-review-frame.jpg');
            const http = await fetch(this.labelReviewRuntimeApi + 'save?' + query.toString(), {
                method: 'POST', body: form, credentials: 'same-origin',
            });
            const responseText = await http.text();
            let response: any = {};
            try { response = responseText ? JSON.parse(responseText) : {}; } catch (_) {
                throw new Error(`현재 프레임 GT 저장 API 응답이 올바르지 않습니다. (HTTP ${http.status})`);
            }
            const { code, data } = response || {};
            if (!http.ok || code !== 200 || !data?.draft_saved || !data?.gt_saved) {
                throw new Error(data?.message || '현재 프레임 라벨을 저장하지 못했습니다.');
            }
            const committedImageId = String(data.image_id || this.current.image_id);
            const fallbackDraft = {
                ...(this.draft || {}),
                ...(data?.retarget?.video_frame_draft || {}),
                gt_saved: true,
                finalized: false,
            };
            const committedItem = data?.item || {
                ...this.current,
                image_id: committedImageId,
                draft: fallbackDraft,
                saved: {
                    ...(this.current?.saved || {}),
                    gt_saved: true,
                    review_finalized: false,
                    frame_gt_count: Number(data?.retarget?.video_frame_gt_count || 1),
                },
                media: {
                    ...(this.current?.media || {}),
                    video_tracking_anchor: data?.retarget?.video_tracking_anchor || this.current?.media?.video_tracking_anchor,
                    video_tracking_anchors: data?.retarget?.video_tracking_anchors || this.current?.media?.video_tracking_anchors,
                },
            };
            const clientError = this.normalizedRoundtripError(expected, committedItem.draft);
            if (clientError > 1e-8) throw new Error('현재 프레임 라벨 저장 후 좌표 검증에 실패했습니다.');
            const row = this.items[this.currentIndex];
            if (row) {
                row.image_id = committedImageId;
                row.video_time_seconds = data?.retarget?.video_time_seconds;
            }
            this.summary = data?.summary || this.summary;
            this.current = committedItem;
            this.draft = JSON.parse(JSON.stringify(committedItem.draft || {}));
            this.equipmentChecklist = {
                outerEdges: Boolean(this.draft?.equipment_gt_checklist?.outer_edges),
                occludedEdges: Boolean(this.draft?.equipment_gt_checklist?.occluded_edges),
                personIndependent: Boolean(this.draft?.equipment_gt_checklist?.person_independent),
            };
            this.roundtripCheck = {
                status: 'PASS', serverNormalizedError: 0,
                clientNormalizedError: clientError,
                screenPixelError: clientError * Math.max(Number(this.imageMetrics.displayWidth || 0), Number(this.imageMetrics.displayHeight || 0)),
                originalPixelError: clientError * Math.max(Number(this.imageMetrics.naturalWidth || 0), Number(this.imageMetrics.naturalHeight || 0)),
                version: Number(this.draft?.version || 0),
            };
            this.pendingVideoFrame = null;
            this.videoEditingCurrentFrame = false;
            this.videoFramePreparing = false;
            this.videoCurrentTime = Number(data?.retarget?.video_time_seconds || 0);
            this.videoAtReviewFrame = true;
            this.stopLiveInference(true);
            this.notice = data?.post_save_refresh_pending
                ? `현재 ${this.videoCurrentTime.toFixed(1)}초 User GT를 데이터셋에 저장했습니다. 화면 정보는 다음 조회에서 동기화되며, 최종 검수 완료는 ‘Bucky 저장 후 다음’을 눌러 주세요.`
                : `현재 ${this.videoCurrentTime.toFixed(1)}초 User GT를 데이터셋에 저장했습니다. 모델 가중치는 바뀌지 않았으며, 재생 추적에 GT 기준을 적용합니다. 최종 검수 완료는 ‘Bucky 저장 후 다음’을 눌러 주세요.`;
        } catch (error: any) {
            this.errorMessage = error?.message || '현재 프레임 라벨을 저장하지 못했습니다.';
        }
        this.saving = false;
        await this.service.render();
        setTimeout(() => this.updateImageMetrics(), 0);
    }

    public async save(next = false, validationOnly = false) {
        if (!this.current || this.saving) return;
        if (!validationOnly && next !== true) {
            this.errorMessage = '저장은 오른쪽 아래 ‘Bucky 저장 후 다음’ 버튼으로만 할 수 있습니다.';
            await this.service.render();
            return;
        }
        if (this.videoEditingCurrentFrame || this.pendingVideoFrame?.blob) {
            this.errorMessage = '현재 프레임 라벨 저장을 먼저 완료한 뒤 Bucky 최종 검수를 저장해 주세요.';
            await this.service.render();
            return;
        }
        if (!validationOnly && !this.detectorReviewReady()) {
            this.errorMessage = this.videoAvailable() && this.liveInferenceCount < 3
                ? '영상을 재생해 최소 3개 프레임의 Bucky 이동 추적을 확인한 뒤 저장해 주세요.'
                : '장비 네 모서리를 GT 확정하거나 Bucky 없음(Hard negative) 또는 판정 불가(학습 제외)로 지정해 주세요.';
            await this.service.render();
            return;
        }
        // A frame GT save intentionally keeps the queue item UNREVIEWED.
        // Convert it to a final decision only inside this explicit
        // "Bucky 저장 후 다음" path.
        if (!validationOnly && this.draft.status === 'UNREVIEWED') {
            const hasFrameGt = Boolean(this.current?.saved?.gt_saved);
            this.draft.status = hasFrameGt ? 'HUMAN_CORRECTED' : 'AUTO_ACCEPTED';
            this.draft.group = hasFrameGt
                ? 'CORRECTION'
                : (this.draft.group === 'EXCLUDED' ? 'NORMAL' : (this.draft.group || 'NORMAL'));
        }
        this.saving = true; this.errorMessage = ''; this.notice = '';
        const expected = JSON.parse(JSON.stringify({
            bucky_bbox: this.draft.bucky_bbox,
            bucky_polygon: this.draft.bucky_polygon,
            pose_keypoints: this.draft.pose_keypoints,
        }));
        await this.service.render();
        try {
            const reviewPayload = this.detectorReviewPayload();
            const response: any = await wiz.call('save', {
                image_id: this.current.image_id,
                validation_only: validationOnly ? 'true' : 'false',
                review: JSON.stringify(reviewPayload),
            });
            const { code, data } = response || {};
            if (code !== 200) throw new Error(data?.message || '저장하지 못했습니다.');
            const committedImageId = String(data?.image_id || this.current.image_id);
            this.summary = data?.summary || this.summary;
            const row = this.items[this.currentIndex];
            if (row && !validationOnly) {
                row.image_id = committedImageId;
                row.status = data.status;
                row.group = data.group;
                if (data?.retarget?.video_time_seconds != null) {
                    row.video_time_seconds = data.retarget.video_time_seconds;
                }
            }
            await this.reloadAndVerify(
                expected,
                data?.roundtrip_verification,
                validationOnly,
                committedImageId,
            );
            const savedTrackingAnchor = data?.retarget?.video_tracking_anchor;
            if (savedTrackingAnchor && this.current?.media) {
                this.current.media.video_tracking_anchor = savedTrackingAnchor;
                this.stopLiveInference(true);
            }
            this.pendingVideoFrame = null;
            this.videoEditingCurrentFrame = false;
            const savedNotice = `${validationOnly ? '브라우저 검증(학습 제외)' : 'Bucky/Pose'} v${String(data.version).padStart(4, '0')} 저장·재조회 ${this.roundtripCheck?.status || 'FAIL'}`;
            if (!validationOnly && next && this.roundtripCheck?.status === 'PASS') {
                await this.removeSavedItemAndOpenNext();
            }
            this.notice = savedNotice + (savedTrackingAnchor ? ' · 재생 추적에 저장 GT 기준 적용' : '');
        } catch (error: any) {
            this.errorMessage = error?.message || '저장하지 못했습니다.';
        }
        this.saving = false; await this.service.render();
    }
}

export default PageXrayLabel_reviewComponent;